import { userData } from '../../../../util/userData';
import { redirectToUrl } from '../../../UserAdministrationContainer/lib/utils';

interface IAvid {
  avid: string
  hier: string
  parentAvid: string
  parentHier: string
  isParent: number
  drillEnd: string
  drillStart: string
  color: string
}
export const drilldownClickHandler = (avidObject: IAvid) => {
  const filters = userData.getFilters();

  //NOTE: If color = #E24585 Then Go UP.
  //NOTE: If not, Go Down
  //NOTE: If de, go to coaching form
  //NOTE: If ds, reload
  const { avid, hier, parentAvid, parentHier, drillEnd, drillStart, color } = avidObject;
  if (color === '#E24585' || drillStart === hier.trim()) {

    filters.hier = parentHier.trim();
    filters.avid = parentAvid.trim();
    $('#hiers').val(parentAvid.trim());
    userData.updateFilters(filters, true);
  } else if (drillEnd !== avid.trim()) {
    filters.hier = hier.trim();
    filters.avid = avid.trim();
    $('#hiers').val(avid.trim());
    userData.updateFilters(filters, true);
  } else {
    filters.hier = hier.trim();
    filters.avid = avid.trim();
    userData.updateFilters(filters, true);
    redirectToUrl('coachingoverview');
  }
}
